import {Card, Stack, css, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	border-radius: 8px;
	border: 2px solid transparent;
	background:
		linear-gradient(white, white) padding-box,
		linear-gradient(296deg, #1539aa 13.42%, #00a6ff 75.86%, #0944ff 92.09%) border-box;
	padding: 16px;
	width: 100%;
`;

export const StyledStack = styled(Stack)`
	padding-bottom: 16px;
	overflow: auto;

	${({theme}) => css`
		::-webkit-scrollbar {
			height: 4px;
		}

		::-webkit-scrollbar-track {
			background: transparent;
			border-radius: 4px;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px;
			background: ${theme.palette.action.disabled};
		}

		::-webkit-scrollbar-thumb:hover {
			background: ${theme.palette.action.disabled};
		}
	`}
`;
